import { createFileRoute, notFound } from '@tanstack/react-router';
import { canUseMockMode } from '@/lib/mock-mode';
import { previewsQuery } from '@/services/content-preview';
import { DraftPreviewPage } from '@/features/admin/draft-preview/draft-preview-page';

// Dreamwell staff only: anyone else gets the not-found page (the API refuses them too).
export const Route = createFileRoute('/_authed/admin/draft-preview')({
  validateSearch: (search: Record<string, unknown>): { id?: string } => (typeof search.id === 'string' && search.id ? { id: search.id } : {}),
  beforeLoad: ({ context: { user } }) => {
    if (!canUseMockMode(user.email)) throw notFound();
  },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(previewsQuery()).catch(() => null),
  component: DraftPreviewPage,
});
